import React from 'react'
import { Button, Modal } from 'semantic-ui-react'

interface ConfirmDeletionModalProps {
  modal: typeof Modal
  close: () => void
  onClose?: () => void
  handleDelete: () => void
  loading: boolean
  title: string | React.ReactNode
  description: string | React.ReactNode
  buttonLabel: string | React.ReactNode
}

const ConfirmDeletionModal: React.FC<ConfirmDeletionModalProps> = ({
  modal: Modal,
  close,
  onClose,
  handleDelete,
  loading,
  title,
  description,
  buttonLabel,
}) => {
  return (
    <Modal size="tiny" onClose={onClose}>
      <Modal.Header>{title}</Modal.Header>
      <Modal.Content>
        <p>{description}</p>
      </Modal.Content>
      <Modal.Actions>
        <Button onClick={close}>Cancel</Button>
        <Button onClick={handleDelete} disabled={loading} loading={loading} negative>
          {buttonLabel}
        </Button>
      </Modal.Actions>
    </Modal>
  )
}

export default ConfirmDeletionModal



// WEBPACK FOOTER //
// ./src/components/Modals/ConfirmDeletionModal.tsx